import React from 'react';
import PropTypes from 'prop-types';
import { startCase, toLower } from 'lodash';

import gerFormattedAge from '../../../utils/getFormattedAge';

import { HorseLink } from '../../../shared/links/ProfileLink';

const HorseCell = ({
    horseName,
    horseSaleName,
    horseCountryOriginCode,
    horseUid,
    horseFirstColourCode,
    horseSex,
    horseAge,
    sireName,
    sireUid,
    sireOfDamName,
    sireOfDamUid,
}) => (
    <div>
        { horseUid ? (
            <HorseLink
                className="hp-progeny-sales__horseName"
                horseStyleName={horseName || horseSaleName}
                horseUid={horseUid}
                whenEmpty={'Unnamed'}
            />
        ) : (
            <span>{horseName || startCase(toLower(horseSaleName))}</span>
        )}
        <span className="hidden-md-up">,</span>
        {horseCountryOriginCode &&
            <span className="hidden-sm-down">{` (${horseCountryOriginCode})`}</span>}
        {horseFirstColourCode ? ` ${horseFirstColourCode}, ` : ' '}
        {horseSex}, {gerFormattedAge(horseAge)}
        <div className="hidden-md-up">
            <HorseLink
                className="ui-link_marked"
                horseStyleName={sireName}
                horseUid={sireUid}
            />
            {' '}
            <HorseLink
                className="ui-link_marked hp-progeny-sales__secondary-link"
                horseStyleName={sireOfDamName}
                horseUid={sireOfDamUid}
            >
                {`(${sireOfDamName})`}
            </HorseLink>
        </div>
    </div>
);

HorseCell.propTypes = {
    horseName: PropTypes.string,
    horseSaleName: PropTypes.string,
    horseCountryOriginCode: PropTypes.string,
    horseUid: PropTypes.number,
    horseFirstColourCode: PropTypes.string,
    horseSex: PropTypes.string,
    horseAge: PropTypes.number,
    sireName: PropTypes.string,
    sireUid: PropTypes.number,
    sireOfDamName: PropTypes.string,
    sireOfDamUid: PropTypes.number,
};

export default HorseCell;



// WEBPACK FOOTER //
// ./src/js/horse/progenySales/components/HorseCell.jsx